import { render, staticRenderFns } from "./listRecommendFriend.vue?vue&type=template&id=8278153c"
import script from "./listRecommendFriend.vue?vue&type=script&lang=js"
export * from "./listRecommendFriend.vue?vue&type=script&lang=js"
import style0 from "./listRecommendFriend.vue?vue&type=style&index=0&id=8278153c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports